import React from 'react';
import { CANADIAN_PROVINCES } from '../../services/canadianTaxAddress';

const INPUT_CLASS = 'w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium outline-none focus:ring-2 focus:ring-indigo-500';

const CanadianAddressFields = ({
  value = {},
  onChange,
  idPrefix = 'address',
  required = true
}) => {
  const setField = (field, nextValue) => {
    onChange({ ...value, [field]: nextValue });
  };

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <label className="sm:col-span-2">
        <span className="mb-2 block text-xs font-bold text-slate-600">Street address</span>
        <input
          id={`${idPrefix}-line1`}
          autoComplete="address-line1"
          required={required}
          value={value.line1 || ''}
          onChange={(event) => setField('line1', event.target.value)}
          className={INPUT_CLASS}
        />
      </label>
      <label className="sm:col-span-2">
        <span className="mb-2 block text-xs font-bold text-slate-600">Apartment, suite, etc. (optional)</span>
        <input
          id={`${idPrefix}-line2`}
          autoComplete="address-line2"
          value={value.line2 || ''}
          onChange={(event) => setField('line2', event.target.value)}
          className={INPUT_CLASS}
        />
      </label>
      <label>
        <span className="mb-2 block text-xs font-bold text-slate-600">City</span>
        <input
          id={`${idPrefix}-city`}
          autoComplete="address-level2"
          required={required}
          value={value.city || ''}
          onChange={(event) => setField('city', event.target.value)}
          className={INPUT_CLASS}
        />
      </label>
      <label>
        <span className="mb-2 block text-xs font-bold text-slate-600">Province or territory</span>
        <select
          id={`${idPrefix}-province`}
          autoComplete="address-level1"
          required={required}
          value={value.province || ''}
          onChange={(event) => setField('province', event.target.value)}
          className={INPUT_CLASS}
        >
          <option value="" disabled>Choose a province</option>
          {CANADIAN_PROVINCES.map((province) => (
            <option key={province} value={province}>{province}</option>
          ))}
        </select>
      </label>
      <label>
        <span className="mb-2 block text-xs font-bold text-slate-600">Postal code</span>
        <input
          id={`${idPrefix}-postal-code`}
          autoComplete="postal-code"
          required={required}
          maxLength="7"
          value={value.postal_code || ''}
          onChange={(event) => setField('postal_code', event.target.value.toUpperCase())}
          className={INPUT_CLASS}
        />
      </label>
    </div>
  );
};

export default CanadianAddressFields;
